const ACTION_BLUEPRINTS = [
  {
    key: 'appeal',
    label: 'Podat odvolání',
    icon: 'basic/file-earmark-text',
    flagKeys: ['podatOdvolani', 'podat_odvolani'],
    initCode: 'DXAPPEAL'
  },
  {
    key: 'narrow',
    label: 'Zúžení',
    icon: 'basic/funnel',
    flagKeys: ['zuzeni'],
    initCode: 'DXNARROW'
  },
  {
    key: 'cancel',
    label: 'Zpětvzetí',
    icon: 'basic/arrow-counterclockwise',
    flagKeys: ['zpetvzeti'],
    initCode: 'DXCANCEL'
  },
  {
    key: 'add',
    label: 'Doplnit',
    icon: 'basic/plus-circle',
    flagKeys: ['doplnitPodani', 'doplnit_podani'],
    initCode: 'DXADD',
    alwaysVisible: true
  }
];

function normalizeCaseActionFlags(source = {}) {
  const result = {};
  ACTION_BLUEPRINTS.forEach(({ key, flagKeys }) => {
    result[key] = flagKeys.some(flagKey => {
      const value = source?.[flagKey];
      if (typeof value === 'string') {
        const lowered = value.trim().toLowerCase();
        if (!lowered) return false;
        return lowered === 'true' || lowered === '1' || lowered === 'ano' || lowered === 'a';
      }
      return Boolean(value);
    });
  });
  return result;
}

function getCaseActionsFromSource(source = {}) {
  const flags = normalizeCaseActionFlags(source);
  return ACTION_BLUEPRINTS
    .map(blueprint => {
      const allowed = Boolean(flags[blueprint.key]);
      const visible = blueprint.alwaysVisible ? true : allowed;
      return {
        ...blueprint,
        enabled: allowed,
        visible,
        disabled: blueprint.alwaysVisible ? !allowed : false
      };
    })
    .filter(action => action.visible);
}

function runCaseAction(actionKey, caseId) {
  if (!actionKey || !caseId) return false;
  const blueprint = ACTION_BLUEPRINTS.find(action => action.key === actionKey);
  if (!blueprint?.initCode) return false;
  if (typeof window !== 'undefined' && typeof window.initFormio === 'function') {
    window.initFormio(blueprint.initCode, null, null, caseId);
    return true;
  }
  return false;
}

export { ACTION_BLUEPRINTS, normalizeCaseActionFlags, getCaseActionsFromSource, runCaseAction };
